import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=35936abc&scoped=true"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=js"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./DarkModeSwitch.vue?vue&type=style&index=0&id=35936abc&prod&scoped=true&lang=css"
import style1 from "./DarkModeSwitch.vue?vue&type=style&index=1&id=35936abc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35936abc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VSwitch})
